
var chartContainer = d3.select("#line-graph").append("div")
  .attr("class", "g-chart-container rep");

var chartContainer1 = d3.select("#line-graph").append("div")
  .attr("class", "g-chart-container dem");

var margin = {top: 10, right: 70, bottom: 20, left: 10},
	widther = d3.select("#line-graph").node().clientWidth;

if (widther > 500) { var width = (widther/2) - margin.left - margin.right }
	else { var width = widther - margin.left - margin.right };

var height = 300 - margin.top - margin.bottom;

var parseDate = d3.time.format("%Y").parse;

//make x scale and range
var x = d3.time.scale()
        .range([0, width]);

//make y scale and range
var y = d3.scale.linear()
        .range([height, 0]);

// Define the axes
var xAxis = d3.svg.axis().scale(x)
    .orient("bottom")
    .ticks(5);

var yAxis = d3.svg.axis().scale(y)
    .orient("right")
    .ticks(4)
    .tickFormat(function(d) { return d + "%"; });;

// Define the line
var animosityLine = d3.svg.line()
    .x(function(d) { return x(d.year); })
    .y(function(d) { return y(d.score); });


d3.csv('data.csv', function(error, data){
	data.forEach(function(d){
		d.score = +d.score;
		d.party = +d.party;
		d.year = parseDate(d.year);
	});

	//set domains
	x.domain(d3.extent(data, function(d){return d.year}));
	y.domain([0, 100])

	//make two different datasets for the two different graphics
	var republicanData = [];
	var democratData = [];

	for (var i = 0; i < (data.length); i++){
		console.log(data[1].opinion)
		if (data[i].party == 1){
			republicanData.push({
				opinion: data[i].opinion,
				year: data[i].year,
				score: data[i].score
			})
		}
		else {
			democratData.push({
				opinion: data[i].opinion,
				year: data[i].year,
				score: data[i].score
			})
		}
	}

	//make differentiators so that I can add different classes to lines later
	var chartKeyRep = ["Very", "Unfave"];
	var chartKeyDem = ["Very", "Unfave"];

	//nest opinions so I can graph two lines on each graphic
	var byOpinionRepublican = d3.nest()
		.key(function(d){return d.opinion;})
		.entries(republicanData);

	var byOpinionDemocrat = d3.nest()
		.key(function(d){return d.opinion;})
		.entries(democratData);

	//Appends the property name to the individual chart container
    var chartTextRepublican = chartContainer.append("h5")
      .attr("class", "chart-title");

    //create legend div
    var legendRepublican = chartContainer.append("div")
      .attr("class", "legend-box");

    //draw GOP svg
	var lineChartRepublican = chartContainer.append('svg')
		.attr('width', width + margin.left + margin.right)
		.attr('height', height + margin.top + margin.bottom)
	.append('g')
		.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

	//apend chart title text
	chartTextRepublican.text("Republicans with an unfavorable view of the Democratic Party")

	byOpinionRepublican.forEach(function(d, i){
		lineChartRepublican.append('path')
			.attr('class', 'line rep-'+chartKeyRep[i])
			.attr('d', animosityLine(d.values))
	});

	lineChartRepublican.append("g")
		.attr("class", "x axis")
		.attr("transform", "translate(0," + height + ")")
		.call(xAxis)

	lineChartRepublican.append("g")
		.attr("class", "y axis")
		.attr("transform", "translate(" + (width) + ",0)")
		.call(yAxis);

	//get rid of 0 on the Republican y axis
	d3.selectAll('.tick')
		.each(function (d) {
	        if ( d === 0 ) {
	            this.remove();
	        }
	    });

	d3.select('.legend-box')
		.append("div")
			.attr("class", "legend unfav-rep")

	d3.select('.legend-box')
		.append("div")
			.attr("class", "legend-text")
			.text("Unfavorable")

	d3.select('.legend-box')
		.append("div")
			.attr("class", "legend v-unfav-rep")

	d3.select('.legend-box')
		.append("div")
			.attr("class", "legend-text")
			.text("Very Unfavorable")

	//Appends the property name to the individual chart container
    var chartTextDemocrat = chartContainer1.append("h5")
      .attr("class", "chart-title");

    //create legend div
    var legendDemocrat = chartContainer1.append("div")
      .attr("class", "legend-box-dem");

	var lineChartDemocrat = chartContainer1.append('svg')
		.attr('width', width + margin.left + margin.right)
		.attr('height', height + margin.top + margin.bottom)
	.append('g')
		.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

	//apend chart title text
	chartTextDemocrat.text("Democrats with an unfavorable view of the Republican Party");

	byOpinionDemocrat.forEach(function(d, i){
		lineChartDemocrat.append('path')
			.attr('class', 'line democrat-'+chartKeyDem[i])
			.attr('d', animosityLine(d.values))
			// .attr('transform', 'translate(' + margin.left + ',0)');
	});

	lineChartDemocrat.append("g")
		.attr("class", "x axis")
		.attr("transform", "translate(0," + height + ")")
		.call(xAxis)

	lineChartDemocrat.append("g")
		.attr("class", "y axis")
		.attr("transform", "translate(" + width + ",0)")
		.call(yAxis)
	
	//get rid of 0 on the Democrat y axis
	d3.selectAll('.tick')
		.each(function (d) {
	        if ( d === 0 ) {
	            this.remove();
	        }
	    });

	d3.select('.legend-box-dem')
		.append("div")
			.attr("class", "legend unfave-dem")
			.style("background-color", "#7b97c9");

	d3.select('.legend-box-dem')
		.append("div")
			.attr("class", "legend-text")
			.text("Unfavorable");

	d3.select('.legend-box-dem')
		.append("div")
			.attr("class", "legend v-unfave-dem");

	d3.select('.legend-box-dem')
		.append("div")
			.attr("class", "legend-text")
			.text("Very Unfavorable");


	//RESPONSIVENESS
	d3.select(window).on("resize", resized);
	
	function resized() {

		//new margin
    		// var newMargin = {top: 20, right: 70, bottom: 20, left: 30};

    		var newMargin = {top: 10, right: 70, bottom: 20, left: 10};

    		var newWidther = d3.select("#line-graph").node().clientWidth;
            var newWidth = newWidther - newMargin.left - newMargin.right;

            if (newWidther > 500) { 
                newWidth = (newWidther/2) - newMargin.left - newMargin.right; 
            } else { 
                newWidth = newWidther - newMargin.left - newMargin.right;
            }

            //adjust x scale and range
    		x.range([0, newWidth]);

    		d3.selectAll("svg")
                .attr("width", newWidth + newMargin.left + newMargin.right)
                // .attr('height', newHeight + newMargin.top + newMargin.bottom)
               // .attr("transform", "translate(" + newMargin.left + "," + newMargin.top + ")");

            //adjust lines
            byOpinionDemocrat.forEach(function(d, i){
	            d3.selectAll('.democrat-'+chartKeyDem[i])
	            	.attr('d', animosityLine(d.values))
	            })

            byOpinionRepublican.forEach(function(d, i){
	            d3.selectAll('.rep-'+chartKeyRep[i])
	            	.attr('d', animosityLine(d.values))
	            })

            d3.selectAll('.x.axis')
                .call(xAxis)

           	d3.selectAll('.y.axis')
				.attr("transform", "translate(" + newWidth + ",0)")
				.call(yAxis)
               

	}

});

